import { errorResponse } from './utils/response-templates.js';
import { z } from './utils/zod.js';
export const invoiceDtoSchema = z.object({
    amountDue: z.number().optional(),
    created: z.string().datetime(),
    currency: z.string(),
    dueDate: z.string().datetime().nullable(),
    id: z.string().optional(),
    invoiceNumber: z.string().nullable(),
    invoicePdf: z.string().optional().nullable(),
    paid: z.boolean(),
    periodEnd: z.string().datetime().nullable(),
    periodStart: z.string().datetime().nullable(),
    subtotal: z.number().optional(),
    tax: z.number().nullable().optional().openapi({ description: 'null when Stripe computed no tax' }),
    total: z.number(),
});
export const invoiceSchemaResponseSchema = z.object({
    success: z.boolean(),
    draft: z.array(invoiceDtoSchema).nullable(),
    invoices: z.array(invoiceDtoSchema),
});
export const listInvoiceInvalidResponseSchema = errorResponse('Invalid request for invoice listing');
